export enum VolumeSource {
    ANNUAL = "ANNUAL",
    FLAT = "FLAT",
    MONTHLY = "MONTHLY",
    SELECT = "SELECT",
    WEEKLY = "WEEKLY"
}